import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';
import { lastValueFrom } from 'rxjs';
import { JobNotificacion } from 'src/app/models/notificacion/job.model';

@Injectable({
  providedIn: 'root'
})
export class JobService extends BaseService {

    recordName = 'jobs_procesamiento';

    url = `${ environment.host }/job`;

    codigoModulo = JobNotificacion.CODIGO_MODULO;
    codigoRegistro = JobNotificacion.CODIGO_REGISTRO;

    /**
     * Crea un nuevo job de procesamiento
     */
    async crearJob(body: Record<string, any>): Promise<any> {
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(`${this.url}/crear-job`, body, { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }

    /**
     * Obtiene el estado de un job
     */
    async getStatus(id: number, id_empresa: number): Promise<any> {
        try {
            await this.updateToken();
            const headers = this.header;
            const params = { id_empresa };
            const resp = await lastValueFrom(this.http.get<any>(`${this.url}/status/${id}`, { headers: headers, params: params }));
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }

    /**
     * Devuelve una campana interrumpida a la cola.
     *
     * Los destinatarios que ya tuvieron su intento no vuelven a recibir el
     * mensaje: el backend los saltea leyendo el ledger de ese job.
     */
    async retomarJob(id: number, id_empresa: number): Promise<any> {
        try {
            await this.updateToken();
            const headers = this.header;
            const body = { id_empresa };
            const resp = await lastValueFrom(this.http.post<any>(`${this.url}/retomar/${id}`, body, { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }

    /**
     * Reenvia la campana a los destinatarios elegidos en el informe.
     *
     * Nace un job nuevo con los mismos parametros de la campana original, asi
     * que el mensaje dice exactamente lo que iba a decir.
     */
    async reenviarDestinatarios(idJob: number, id_empresa: number, telefonos: string[]): Promise<any> {
        try {
            await this.updateToken();
            const headers = this.header;
            const body = { id_empresa, telefonos };
            const resp = await lastValueFrom(this.http.post<any>(`${this.url}/reenviar/${idJob}`, body, { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }

    /**
     * Cancela un job
     */
    async cancelarJob(id: number, id_empresa: number): Promise<any> {
        try {
            await this.updateToken();
            const headers = this.header;
            const body = { id_empresa };
            const resp = await lastValueFrom(this.http.post<any>(`${this.url}/cancelar/${id}`, body, { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError(error);
        }
    }
}